import { render, staticRenderFns } from "./BusinessLogos.vue?vue&type=template&id=38583c70&scoped=true&"
import script from "./BusinessLogos.vue?vue&type=script&lang=ts&"
export * from "./BusinessLogos.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessLogos.vue?vue&type=style&index=0&id=38583c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38583c70",
  null
  
)

export default component.exports